import { Routes, Route } from 'react-router';

import type { Overwrite } from '~/utils/types';

import { TestingRoute, RemoteRoutes, TESTING_ROUTE_PREFIX_PATH } from '../Routes';

import type { TestingRouteProps } from '../Routes';

export type TRoutingProps = Overwrite<
  TestingRouteProps,
  {
    TestingApplication?: () => JSX.Element;
    testingRoute?: string;
  }
>;

function Routing({
  TestingApplication,
  testingRoute,
  graphqlEndpoint,
  collectorUrl,
  enableRedux,
  enableDatadog,
  isProtected,
  layout,
  environmentOptions,
}: TRoutingProps) {
  return (
    <Routes>
      {TestingApplication && testingRoute && (
        <Route
          path={TESTING_ROUTE_PREFIX_PATH}
          element={
            <TestingRoute
              enableRedux={enableRedux}
              TestingApplication={TestingApplication}
              testingRoute={testingRoute}
              graphqlEndpoint={graphqlEndpoint}
              collectorUrl={collectorUrl}
              enableDatadog={enableDatadog}
              isProtected={isProtected}
              layout={layout}
              environmentOptions={environmentOptions}
            />
          }
        />
      )}

      <Route path={'*'} element={<RemoteRoutes />} />
    </Routes>
  );
}

export default Routing;
export { default as NamespacedRouting } from './NamespacedRouting';
